import { E as Environment } from "./chunks/environment-BHIxEh0R.js";
const LOCAL_HOSTNAMES = ["localhost", "127.0.0.1"];
const STAGING_HOSTNAMES = [
  "staging.color.com",
  "home.staging.color.com",
  "home.use1-a.eks.staging.color.com",
  "clinical.staging.color.com",
  "genomics-stb.joinallofus.org",
  "gp-staging.use1-a.eks.staging.color.com",
  "rhp-staging.use1-a.eks.staging.color.com",
  "aou-pdf.use1-a.eks.staging.color.com",
  "color-hub.use1-a.eks.staging.color.com",
  "hub.staging.color.com"
];
const TESTING_HOSTNAMES = ["gp-testing.use1-a.eks.staging.color.com"];
const PRODUCTION_HOSTNAMES = [
  "home.color.com",
  "home.use1-a.eks.color.com",
  "clinical.color.com",
  "genomics.joinallofus.org",
  "joinallofus.org",
  "rhp.aou.color.com",
  "aou-pdf.use1-a.eks.color.com",
  "hub.color.com"
];
function isEnvironmentLocal() {
  return LOCAL_HOSTNAMES.includes(window.location.hostname);
}
function isEnvironmentStaging() {
  return STAGING_HOSTNAMES.includes(window.location.hostname);
}
function isEnvironmentTesting() {
  return TESTING_HOSTNAMES.includes(window.location.hostname);
}
function isEnvironmentProduction() {
  return PRODUCTION_HOSTNAMES.includes(window.location.hostname);
}
function isEnvironmentEphemeral() {
  return window.location.hostname.startsWith("ephemeral-") && window.location.hostname.endsWith(".use1-a.eks.color.dev");
}
function isEnvironmentLocalAndDevelopment() {
  return isEnvironmentLocal() && window.__ENV__ === "development";
}
function isEnvironmentCypressTest() {
  return isEnvironmentLocal() && window.Cypress !== void 0;
}
function getEnvironment() {
  if (isEnvironmentCypressTest()) {
    return Environment.CYPRESS_TEST;
  }
  if (isEnvironmentLocal()) {
    return Environment.LOCAL;
  }
  if (isEnvironmentStaging()) {
    return Environment.STAGING;
  }
  if (isEnvironmentTesting()) {
    return Environment.TESTING;
  }
  if (isEnvironmentProduction()) {
    return Environment.PRODUCTION;
  }
  if (isEnvironmentEphemeral()) {
    return Environment.EPHEMERAL;
  }
  return Environment.UNKNOWN;
}
function getEnvironmentOrDefault(defaultEnv) {
  if (isEnvironmentLocal()) {
    return Environment.LOCAL;
  }
  if (isEnvironmentStaging()) {
    return Environment.STAGING;
  }
  if (isEnvironmentTesting()) {
    return Environment.TESTING;
  }
  if (isEnvironmentProduction()) {
    return Environment.PRODUCTION;
  }
  return defaultEnv;
}
export {
  Environment,
  getEnvironment,
  getEnvironmentOrDefault,
  isEnvironmentCypressTest,
  isEnvironmentEphemeral,
  isEnvironmentLocal,
  isEnvironmentLocalAndDevelopment,
  isEnvironmentProduction,
  isEnvironmentStaging,
  isEnvironmentTesting
};
//# sourceMappingURL=Environment.js.map
